const environment = process.env.NODE_ENV || 'development';

let protocol = 'https'

if (environment === 'development') {
    let protocol = 'http'
}

export const host = `${protocol}://${window.location.host}`